import { Box, Text } from '@jfs/ui-new';
import { Icon } from '@jfs/ui-new/src/comps/IconNew';
import { ViewStyle } from 'react-native';

interface ServiceHighlightsProps {
  containerStyle?: ViewStyle;
}

export const ServiceHighlights = ({ containerStyle }: ServiceHighlightsProps) => {
  return (
    <Box
      flexDirection={'column'}
      p={16}
      backgroundColor={'WHITE'}
      borderRadius={8}
      shadowColor={'BLACK'}
      shadowOpacity={0.1}
      shadowRadius={4}
      style={containerStyle}
    >
      {/* Row 1: Registration */}
      <Box flexDirection={'row'} alignItems={'flex-start'} mb={6}>
        <Box alignItems="center">
          <Icon id="SUCCESSFUL_FILLED" size={24} color={'BRAND_PRIMARY_GREEN'} />
          <Box
            height={20}
            borderLeftWidth={1}
            borderLeftColor={'BRAND_PRIMARY_ACTION'}
            borderStyle={'dotted'}
            mt={4}
          />
        </Box>
        <Box ml={8}>
          <Text>Click on Register now button below</Text>
        </Box>
      </Box>

      {/* Row 2: Bill Payments */}
      <Box flexDirection={'row'} alignItems={'flex-start'} mb={6}>
        <Box alignItems="center">
          <Icon id="MOBILE" size={24} color={'BRAND_PRIMARY_GREEN'} />
          <Box
            height={20}
            borderLeftWidth={1}
            borderLeftColor={'BRAND_PRIMARY_ACTION'}
            borderStyle={'dotted'}
            mt={4}
          />
        </Box>
        <Box ml={8}>
          <Text>Make Bill Payments for your customer</Text>
        </Box>
      </Box>
      {/* <Box flexDirection={'row'} alignItems={'center'} mb={16}>
        <Icon id="CHECKBOX_CHECKED" size={24} color={'BRAND_PRIMARY_RED'} />
        <Box ml={8}>
          <Text>Make Bill Payments for your customer</Text>
        </Box>
      </Box> */}

      {/* Row 3: Collection */}

      <Box flexDirection={'row'} alignItems={'flex-start'} mb={6}>
        <Box alignItems="center">
          <Icon id="LOAD_MONEY" size={24} color={'BRAND_PRIMARY_GREEN'} />
          {/* <Box
            height={20}
            borderLeftWidth={1}
            borderLeftColor={'BRAND_PRIMARY_ACTION'}
            borderStyle={'dotted'}
            mt={4}
          /> */}
        </Box>
        <Box ml={8}>
          <Text>Collect amount from customers with convenience fee</Text>
        </Box>
      </Box>
      {/* <Box flexDirection={'row'} alignItems={'center'}>
        <Icon id="CHECKBOX_CHECKED" size={24} color={'BRAND_PRIMARY_BG'} />
        <Box ml={8}>
          <Text>Collect amount from customers with convenience fee</Text>
        </Box>
      </Box> */}
    </Box>
  );
};